/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

export enum AudioCodec {
  OPUS = 0,
  AAC = 1
}

export type AudioCodecType = 'OPUS' | 'AAC';